export const GROUP = {
  GERENTE: 'gerente'
}
